var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="about_empty"> <section class="page-info-block"> <div class="container"> <div class="page-info clearfix"> <ol class="breadcrumb pull-left"> <li><a href="#Index"><i class="fa fa-home"></i></a></li> <li class="active">'+
((__t=( resources['X100749'] ))==null?'':__t)+
'</li> </ol> </div> </div> </section> <section class="content-block page-bg"> <div class="overlay tint"> <div class="container"> <div class="row"> <div class="col-sm-12 col-md-12 vspace-xs"> <h4>'+
((__t=( resources['X100750'] ))==null?'':__t)+
'</h4> <p>'+
((__t=( resources['X100751'] ))==null?'':__t)+
'</p> <p>'+
((__t=( resources['X100606'] ))==null?'':__t)+
'</p> <p>'+
((__t=( resources['X100607'] ))==null?'':__t)+
'</p> <p>'+
((__t=( resources['X100608'] ))==null?'':__t)+
'</p> </div> </div> </div> </div> </section> <section class="content-block default-bg"> <div class="container" style="padding-top:30px;padding-bottom:30px"> <div class="row"> <div class="col-sm-4 col-md-4"> <img src="images/app01.jpg" class="approtateleft" alt="pic" style="width:50%"> </div> <div class="col-sm-8 col-md-8 vspace-xs">  <div class="row"> <div class="col-xs-12 col-sm-12 col-md-12"> <ul class="icon-listlist-unstyled list-icon mb20"> <li>'+
((__t=( resources['X100752'] ))==null?'':__t)+
'</li> <li>'+
((__t=( resources['X100753'] ))==null?'':__t)+
'</li> <li>'+
((__t=( resources['X100754'] ))==null?'':__t)+
'</li> <li>'+
((__t=( resources['X100755'] ))==null?'':__t)+
'</li> <li>'+
((__t=( resources['X100756'] ))==null?'':__t)+
'</li> <li>'+
((__t=( resources['X100757'] ))==null?'':__t)+
'</li> <li>'+
((__t=( resources['X100758'] ))==null?'':__t)+
'</li> <li>'+
((__t=( resources['X100759'] ))==null?'':__t)+
'</li> <li>'+
((__t=( resources['X100760'] ))==null?'':__t)+
'</li>  </ul> </div> </div> </div> </div> </div> </section> </div>';
}
return __p;
};
